const parseId = (id: string): number | undefined => {
    if (!id) return undefined
    if (id.toLowerCase() == 'add') {
        return 0
    } else {
        return parseInt(id)
    }
}
export default parseId
